import { convertToRaw } from "draft-js";
import HTMLtoDraft from "../../utils/HTMLtoDraft/HTMLtoDraft";

import { emptyNote } from "../Notes/utils";

// Service Imports
import { createMultipleNotes } from "../../actions/NotesActions/notesService";

// Declarations
const ALLOWED_ENTITY_TYPES_FOR_NOTES = ["COMMENTS", "DELETED", "INSERTED"];

class CreateDocumentNotes {
  constructor(documentDetails) {
    const { id, mode, components } = documentDetails;
    this.docID = id;
    this.mode = mode;
    this.components = components || [];
  }

  _getSectionNotes = section => {
    const {
      content: { data, section_type: type, section_id: sectionId },
    } = section;
    if (type !== "HTML" || typeof data !== "string") {
      return [];
    }
    const contentState = HTMLtoDraft(data, this.mode);
    const raw = convertToRaw(contentState);
    const { blocks, entityMap } = raw;
    const notes = [];
    blocks.forEach(block => {
      const { text, entityRanges } = block;
      entityRanges.forEach(entity => {
        const { offset, length, key } = entity;
        const entityData = entityMap[key];
        const {
          type,
          data: { id },
        } = entityData;
        if (ALLOWED_ENTITY_TYPES_FOR_NOTES.includes(type)) {
          notes.push({
            id,
            type,
            sectionId,
            text: text.substr(offset, length),
          });
        }
      });
    });
    return notes;
  };

  _documentNotes = component => {
    let docNotes = [];
    component.forEach(section => {
      const sectionNotes = this._getSectionNotes(section);
      if (
        sectionNotes &&
        Array.isArray(sectionNotes) &&
        sectionNotes.length > 0
      ) {
        docNotes = docNotes.concat(sectionNotes);
      }
    });
    return docNotes;
  };

  _noteMessage = type => {
    switch (type) {
      case "inserted":
        return "Customer added this text";
      case "deleted":
        return "Customer deleted this text";
      default:
        return "";
    }
  };

  _createNotes = docNotes => {
    const commentComponent = this.components.find(
      component =>
        component.content && component.content.section_type === "Comments",
    );
    const commentData =
      commentComponent &&
      commentComponent.content &&
      commentComponent.content.data
        ? commentComponent.content.data
        : null;
    const notesList = [];
    docNotes.forEach(noteData => {
      const { id, text, type, sectionId } = noteData;
      const typeObj = type.toLowerCase();
      if (typeObj === "comments" && commentData && commentData[id]) {
        const note = emptyNote(this.docID, null);
        note.content = {
          [typeObj]: text,
          message: this._noteMessage(typeObj),
        };
        const noteMessage = commentData[id];
        note.content.message = noteMessage.data;
        note.anchor = {
          component: "DOCUMENT",
          component_id: sectionId,
          action: type,
          id,
        };
        notesList.push(note);
      } else if (typeObj === "deleted" || typeObj === "inserted") {
        const note = emptyNote(this.docID, null);
        note.content = {
          [typeObj]: text,
          message: this._noteMessage(typeObj),
        };
        note.content.message = text;
        note.anchor = {
          component: "DOCUMENT",
          component_id: sectionId,
          action: type,
          id,
        };
        notesList.push(note);
      }
    });
    createMultipleNotes(notesList);
    return notesList;
  };

  create() {
    if (Array.isArray(this.components) && this.components.length > 0) {
      const notes = this._documentNotes(this.components);
      const createdNotes = this._createNotes(notes);
      return createdNotes;
    }
  }
}

export default CreateDocumentNotes;
